<template>
  <div>
    <el-form ref="form" label-width="120px" :model="myForm" :rules="rules" inline>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="mac">
            <el-input v-model="myForm.mac" placeholder="请输入设备MAC地址"></el-input>
          </el-form-item>

          <el-form-item prop="cloud">
            <el-select v-model="myForm.cloud" placeholder="请选择云平台" style="width: 160px;">
            <el-option
              v-for="cloud in cloudEnvList"
              :label="cloud"
              :key="cloud"
              :value="cloud"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="action">
            <el-select multiple v-model="myForm.action" placeholder="请选择动作类型（多选）">
            <el-option
              v-for="action in deviceActionTypes"
              :label="action.name"
              :key="action.value"
              :value="action.value"></el-option>
            </el-select>
          </el-form-item>
        <!-- </el-col>
        <el-col :span="24"> -->
          <el-form-item prop="switch" label="动作监控开关">
            <el-select v-model="myForm.switch" placeholder="开启或关闭动作监控" style="width: 100px;">
            <el-option
              v-for="status in switchStatus"
              :label="status"
              :key="status"
              :value="status"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="days" label="监控天数">
            <el-input v-model="myForm.days" placeholder="请输入监控天数"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onAutoSubmit">下发动作监控配置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <List
      url="device-action/info/"
      :title="title"
      ref="list"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
        <el-select multiple v-model="selectClouds" placeholder="选择云平台（多选）" style="width:200px;margin-right:10px;" size="small">
          <el-option
            v-for="cloud in cloudEnvList"
            :label="cloud"
            :key="cloud"
            :value="cloud"></el-option>
        </el-select>
        <el-input
          v-model="searchData.mac"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="请输入设备MAC地址"
        ></el-input>
        <el-button
          @click="search"
          type="primary"
          size="small"
          >Search</el-button>
      </div>
       <template v-slot:slot-switch="scope" >
         <el-switch v-model="scope.item.switchOriginValue" @change="changeSwicth($event,scope.item)"></el-switch>
      </template>

      <template v-slot:slot-effective="scope" >
        <el-tag :type="scope.item.effectiveOriginValue ? 'success' : 'danger'">{{ scope.item.effective }}</el-tag>
      </template>
    </List>
    <ActionInfoUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      :cloudEnvList="cloudEnvList"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></ActionInfoUpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import ActionInfoUpdateBox from "../components/DeviceAction/ActionInfoUpdateBox.vue";
import { SwitchStatus, DeviceActionTypes } from "@/components/Index/data.js";

export default {
  components: {
    List,
    ActionInfoUpdateBox
  },
  data() {
    return {
      dialogFormVisible: false,
      myForm: {
        mac: "",
        cloud: "",
        action: [],
        switch: "开启",
        days: "7"
      },
      rules: {
        mac: [{required: true, message: "请输入设备MAC地址", trigger: "blur"}],
        cloud: [{required: true, message: "请选择云平台", trigger: "blur"}],
        action: [{required: true, message: "请选择动作类型", trigger: "blur"}],
        switch: [{required: true, message: "开启或关闭动作监控", trigger: "blur"}],
        days: [{required: true, message: "请输入监控天数", trigger: "blur"}]
      },
      title: "设备动作监控",
      tanle: [
        { name: "mac", label: "设备MAC地址" },
        { name: "action", label: "动作监控类型" },
        { name: "switch", label: "动作监控开关" },
        { name: "days", label: "动作监控天数" },
        { name: "effective", label: "动作监控状态" },
        { name: "cloud", label: "云平台" },
        { name: "update_time", label: "修改时间" },
        { name: "operator", label: "最近一次操作人" }
      ],
      deviceActionTypes: DeviceActionTypes,
      switchStatus: SwitchStatus,
      selectClouds: [],
      searchData: {
        cloud: "",
        mac: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        // {
        //   text: "Deletedata",
        //   eventName: "deletedata"
        // }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      cloudEnvList: [],
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
  },
  methods: {
    onAutoSubmit() {
      this.$refs.form.validate(valid => {
        let formData = this.myForm;
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        this.$http["post"](
          "device-action/info/",
          {
            mac: formData.mac,
            cloud: formData.cloud,
            action: formData.action.reduce((a, b) => a | b, 0),
            switch: +(formData.switch === '开启'),
            days: formData.days,
          },
          () => {
            this.$baseNotice.message("创建成功");
            this.updateList++;
          }
        );
      });
    },
    getActionNames(value) {
      if (!value) return [];
      return DeviceActionTypes.filter(actionType => (value & actionType.value) !== 0).map(actionType => actionType.name);
    },
    dealList(data) {
      for (let i in data) {
        data[i].actionOriginValue = data[i].action;
        data[i].switchOriginValue = data[i].switch;
        data[i].effectiveOriginValue = data[i].effective;
        data[i].update_time = this.changeDate(data[i].update_time);
        data[i].action = this.getActionNames(data[i].action).join(', ');  // 把数字转换成对应的动作
        data[i].switch = data[i].switch ? "开启" : "关闭";
        data[i].effective = data[i].effective ? "生效中" : "已停止";
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      // 把动作名称转换成 action 数组形式
      this.updateForm.action = val.action.split(', ').map((actionName) =>
        this.deviceActionTypes.find((actionType) => actionType.name === actionName).value
      );
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    search() {
      this.searchData.cloud = this.selectClouds.join(",");
      this.updateList++;
    },
    deletedata(val) {
      let url = "device-action/info/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeSwicth(changeValue,itemData){
      var params = {
        mac: itemData.mac,
        cloud: itemData.cloud,
        action: itemData.actionOriginValue,
        days: itemData.days,
        switch: +(changeValue)
      };
      var url = "device-action/info/";
      this.$http["post"](
        url,
        params,
        () => {
          this.$baseNotice.message("下发成功");
          this.$refs.list.backFirstPage();
          this.updateList++;
        }
      );
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.cloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
